import {Component} from '@angular/core';
import {EmpresaService} from '../empresa/empresa.service';
import {SucursalService} from '../sucursal/sucursal.service';
import {NodoService} from '../nodo/nodo.service';
import {MedicionService} from '../medicion/medicion.service';
import {RegAlarmaService} from '../regAlarma/regAlarma.service';
import {ProgressService} from '../customBrowserXhr/progress.service';
import {LoginService} from '../login/login.service';
import {ErrorNotifierService} from '../error-notifier/error.notifier';

import {Empresa} from '../empresa/empresa';
import {Sucursal} from '../sucursal/sucursal';
import {Nodo} from '../nodo/nodo';
import {Ubicacion} from '../ubicacion/ubicacion';
import {RegAlarma} from '../regAlarma/regAlarma';
import {InformeService} from "../informes/informe.service";

import {DateTimeZonePipe} from '../pipes/dateTimeZonePipe';
import myGlobals = require('../config');

declare var $: any;


var Highcharts = require('highcharts');

// Load module after Highcharts is loaded
require('highcharts/modules/exporting')(Highcharts);
var moment = require('moment');

var ChartGlobal;

declare function escape(s: string): string;

declare function unescape(s: string): string;


@Component({
    selector: 'historico',
    //directives: [CHART_DIRECTIVES],
    template: require('../../app/historico/historico.component.html'),
    styles: [require('../../app/historico/historico.component.css')],
    pipes: [DateTimeZonePipe]
})

export class HistoricoComponent {
    empresas: Empresa[];
    empresaSeleccionada: Empresa;
    sucursales: Sucursal[];
    //sucursalSeleccionada: string;
    sucursalSeleccionada: Sucursal;
    offsetTimeZone: string;
    ubicaciones: Ubicacion[];
    nodos: Nodo[];
    socket: any;
    ultimoColor: number;
    colors: Array<any>;
    regAlarma: RegAlarma[];
    promedios: any;
    promediosMKT: any;
    minMaxValues: any;
    regAlarmaNodos: RegAlarma[];
    abierto: any;
    ejeY: boolean;
    asignacionColor: any;
    noData: any;
    fechaDesde: any;
    fechaHasta: any;
    progressBar: any;
    loading: boolean;
    mostrarEliminados: boolean;
    mostrarTemperaturaMedia: boolean;
    usuarioConectado: any;

    constructor(private empresaService: EmpresaService,
                private sucursalService: SucursalService,
                private nodoService: NodoService,
                private medicionService: MedicionService,
                private regAlarmaService: RegAlarmaService,
                private progressService: ProgressService,
                private loginService: LoginService,
                private informeService: InformeService,
                private errorNotifier: ErrorNotifierService) {

    }

    ngOnInit() {
        window.scrollTo(0, 0);

        this.usuarioConectado = this.loginService.getDecodeToken();

        this.progressBar = 0;
        this.loading = false;
        this.regAlarma = [];
        this.regAlarmaNodos = [];
        this.promedios = new Map();
        this.promediosMKT = new Map();
        this.minMaxValues = new Map();
        this.asignacionColor = new Map();
        this.abierto = true;
        this.ultimoColor = 0;
        this.ejeY = true;
        this.noData = true;
        this.mostrarEliminados = false;
        this.mostrarTemperaturaMedia = true;
        this.ubicaciones = [];
        this.colors = ['#058DC7', '#50B432', '#ED561B', '#ae1316', '#8d02f7', '#64E572', '#FF9655', '#0da6a1', '#ff0000'];

        this.offsetTimeZone = "-03:00";

        this.fechaDesde = new Date().toISOString().substring(0, 10);
        this.fechaHasta = new Date().toISOString().substring(0, 10);

        //Suscribirse a errores
        this.errorNotifier.onError((error) => {
            this.loading = false;
            this.progressBar = 0;
            this.uncheckAllSensors();
        });

        //Obtener empresas de ese usuario
        this.empresaService.getEmpresas()
            .subscribe(
                data => {
                    this.empresas = data;
                    if (data.length > 0)
                        this.cambiarSucursales(data[0]._id);
                });

        Highcharts.setOptions({
            lang: {
                loading: 'Cargando...',
                months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
                shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                exportButtonTitle: "Exportar",
                printButtonTitle: "Importar",
                rangeSelectorFrom: "Desde",
                rangeSelectorTo: "Hasta",
                rangeSelectorZoom: "Zoom",
                downloadPNG: 'Descargar imagen PNG',
                downloadJPEG: 'Descargar imagen JPEG',
                downloadPDF: 'Descargar imagen PDF',
                downloadSVG: 'Descargar imagen SVG',
                printChart: 'Imprimir',
                resetZoom: 'Reiniciar zoom',
                resetZoomTitle: 'Reiniciar zoom',
                thousandsSep: ",",
                decimalPoint: '.'
            }
        });


        ChartGlobal = Highcharts.stockChart('container', {
            chart: {
                zoomType: 'xy',
                marginTop: 150,
            },
            title: null,
            tooltip: {
                shared: true,
            },
            xAxis: {
                ordinal: false
            },
            legend: {
                enabled: true,
                maxHeight: 100,
                layout: 'vertical',
                align: 'left',
                x: 10,
                verticalAlign: 'top',
                y: 2,
                floating: true,
                backgroundColor: '#FFFFFF',
                labelFormatter: function () {
                    if (this.name.indexOf('Bateria') !== -1) {
                        return this.name + ' <span style="font-size: 10px; font-style: italic">(---- para alimentación externa)</span>';
                    } else {
                        return this.name;
                    }
                }
            },
            credits: {
                enabled: false
            },
            rangeSelector: {
                buttons: [{
                    type: 'hour',
                    count: 1,
                    text: '1 hora'
                }, {
                    type: 'day',
                    count: 1,
                    text: '24hs'
                }, {
                    type: 'month',
                    count: 1,
                    text: '1 mes'
                }, {
                    type: 'year',
                    count: 1,
                    text: '1 año'
                }, {
                    type: 'all',
                    count: 1,
                    text: 'Todo'
                }],
                selected: 4,
                inputEnabled: true,
                inputEditDateFormat: '%d-%m-%Y',
                inputDateFormat: '%d-%m-%Y',
                xAxis: {
                    ordinal: false
                },
            },
            exporting: {
                enabled: false,
                csv: {
                    dateFormat: '%d-%m-%Y %H:%M:%S'
                },
                chartOptions: {
                    title: {
                        text: "Gráficos",
                        style: {
                            fontSize: '26px'
                        }
                    },
                    subtitle: {
                        text: 'fecha'
                    },
                    xAxis: {
                        labels: {
                            style: {
                                fontSize: '16px'
                            }
                        },
                    },
                    legend: {
                        itemStyle: {
                            fontSize: '16px'
                        }
                    },
                    yAxis: {
                        labels: {
                            style: {
                                fontSize: '26px'
                            }
                        }
                    }
                }
            },
            navigator: {
                series: {
                    includeInCSVExport: false
                },
                adaptToUpdatedData: true
            },
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 769
                    },
                    chartOptions: {
                        legend: {
                            y: 40,
                            maxHeight: 100
                        },
                        chart: {
                            marginTop: 200,
                            pinchType: 'x',
                            panning: true
                        },
                        rangeSelector: {
                            buttonPosition: {},
                            inputPosition: {
                                y: 160
                            }
                        },
                        scrollbar: {
                            liveRedraw: true
                        }
                    }

                }]
            },
            series: [{
                showInLegend: false,
                type: 'scatter',
                marker: {
                    enabled: false
                },
                enableMouseTracking: false,
                data: null
            }]
        });

        //Corregir defecto de nombre en plotlines en versiones viejas
        Highcharts.wrap(Highcharts.Axis.prototype, 'getPlotLinePath', function (proceed) {
            var path = proceed.apply(this, Array.prototype.slice.call(arguments, 1));
            if (path) {
                path.flat = false;
            }
            return path;
        });

        setTimeout(function () {
            ChartGlobal.reflow();
        }, 300);

        //Ocultar la barra cuando hace click afuera
        if ($(window).width() < 769)
            $(document).bind("mouseup touchend", function (e) {
                var container = $("#barraSelectora");
                if (!container.is(e.target) // if the target of the click isn't the container...
                    && container.has(e.target).length === 0
                    && e.target.id != "iconoBarraSelectora" && e.target.className != "botonConfig" && e.target.id != "desBarraSelectora"
                    && e.target.id != "flechaBarraSelectora") // ... nor a descendant of the container
                {
                    $('#barraSelectora').css("display", "none");
                }
            });
    }

    ngOnDestroy() {
    }

    cambiarSucursales(id) {
        //Buscar empresa
        this.empresas.forEach(function (empresa) {
            if (empresa._id == id) {
                this.empresaSeleccionada = empresa;
                return
            }
        }.bind(this));

        //Vaciar grafico cuando cambio de variable
        this.noData = true;
        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    $("#" + sensor._id).attr('checked', false);
                    let e = {target: document.getElementById(sensor._id)};
                    this.graficar(e, sensor);
                }
            }
        }


        this.sucursalService.getSucursalByEmpresa(id).subscribe((data) => {
            this.sucursales = data;
            if (data.length > 0) {
                //Calcular fechaDesde para mostrar histórico
                var fechaDesde = new Date();
                fechaDesde.setDate(fechaDesde.getDate() - data[0].historico_dias);
                this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
                this.cambiarSensores(data[0]._id);
            } else {
                this.sucursales = [];
                this.ubicaciones = [];
            }
        });
    }

    cambiarFecha() {
        //Vaciar grafico cuando cambio de variable
        this.noData = true;
        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    $("#" + sensor._id).attr('checked', false);
                    let e = {target: document.getElementById(sensor._id)};
                    this.graficar(e, sensor);
                }
            }
        }

        if (this.fechaDesde > this.fechaHasta)
            alert("La fecha desde no puede ser mayor a la fecha hasta.");
    }

    cambiarSensores(id) {
        //Vaciar grafico cuando cambio de variable
        this.noData = true;
        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    $("#" + sensor._id).attr('checked', false);
                    let e = {target: document.getElementById(sensor._id)};
                    this.graficar(e, sensor);
                }
            }
        }

        //Calcular offset huso horario
        this.sucursales.forEach(function (sucursal) {
            if (sucursal._id == id) {
                this.sucursalSeleccionada = sucursal;
                if (sucursal && sucursal.husoHorario_id && sucursal.husoHorario_id.offset)
                    this.offsetTimeZone = sucursal.husoHorario_id.offset;
                else
                    this.offsetTimeZone = "-03:00";
                return
            }
        }.bind(this));

        //Calcular fechaDesde para mostrar histórico
        var fechaDesde = new Date();
        fechaDesde.setDate(fechaDesde.getDate() - this.sucursalSeleccionada.historico_dias);
        this.fechaDesde = fechaDesde.toISOString().substring(0, 10);
        this.ubicaciones = [];
        //Buscar sensores
        this.nodoService.getNodosBySucursal(id).subscribe((data) => {
                let i = 0;
                let ubicacionAnt = null;
                let nodo = null;
                this.nodos = data;
                var ubicacion = null;
                this.ubicaciones = [];


                while (i < this.nodos.length) {
                    nodo = this.nodos[i];
                    ubicacionAnt = nodo.ubicacion_id._id;
                    ubicacion = new Ubicacion();
                    ubicacion = nodo.ubicacion_id;
                    ubicacion.sensores = [];
                    while (i < this.nodos.length && ubicacionAnt == nodo.ubicacion_id._id) {
                        ubicacion.sensores = ubicacion.sensores.concat(nodo.sensores_id);
                        i++;
                        nodo = this.nodos[i];
                    }
                    this.ubicaciones.push(ubicacion);
                }
            }
        );


    }

    roundNumber(num, scale) {
        if (!("" + num).includes("e")) {
            return +(Math.round(parseFloat(num + "e+" + scale)) + "e-" + scale);
        } else {
            var arr = ("" + num).split("e");
            var sig = ""
            if (+arr[1] + scale > 0) {
                sig = "+";
            }
            return +(Math.round(parseFloat(+arr[0] + "e" + sig + (+arr[1] + scale))) + "e-" + scale);
        }
    }

    graficar(e, sensor) {
        var chart = ChartGlobal;

        //Borrar los rango de alarma de referencia
        if (this.checkAlarmasDiferentes() === true)
            chart.yAxis.forEach((axis) => {
                axis.removePlotLine();
            });

        if (e.target.checked) {
            setTimeout(function () {
                chart.reflow();
            }, 100);
            //Deshabilitar
            // for (let ubicacion of this.ubicaciones) {
            //     for (let sensor of ubicacion.sensores) {
            //         $("#" + sensor._id).attr('disabled', true);
            //     }
            // }
            this.progressBar = 1;
            this.progressService.progressEventObservable.subscribe((progreso) => {
                if (progreso.currentTarget.responseURL.indexOf("medicion") > -1) {
                    let progresoPorc = (progreso.loaded * 100) / progreso.total;
                    if (progreso !== this.progressBar) {
                        this.progressBar = progresoPorc;
                    }
                    if (this.progressBar == 100)
                        setTimeout(() => this.progressBar = 0, 5000);
                }
            });
            this.loading = true;
            this.medicionService.getAllMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(
                (data) => {
                    this.loading = false;
                    //Guardo puntos de la serie
                    let valores = [];
                    //Zonas para alimentacion externa bateria
                    let zonas = [];
                    let tipoAlimentacionAnt = null;
                    //Recorro las mediciones
                    let i = 0;
                    for (let medicion of data) {
                        i++;
                        //Calculo fecha
                        var fechaMedicion = moment(medicion.fecha.toString()).utcOffset(this.offsetTimeZone);
                        //Armo medicion
                        let nuevo = [];
                        var day = fechaMedicion.date();
                        var monthIndex = fechaMedicion.month();
                        var year = fechaMedicion.year();
                        var hour = fechaMedicion.hour();
                        var minutes = fechaMedicion.minutes();
                        var seconds = fechaMedicion.seconds();
                        //Calculo eje x
                        var x = Date.UTC(year, monthIndex, day, hour, minutes, seconds);
                        nuevo.push(x);
                        nuevo.push(medicion.valor);
                        //Guardo medicion
                        valores.push(nuevo);
                        //Tipo alimentacion
                        if (tipoAlimentacionAnt !== null && medicion.alimentacionExterna !== tipoAlimentacionAnt && sensor.posicionString === 9) {
                            tipoAlimentacionAnt = medicion.alimentacionExterna;
                            zonas.push({
                                value: x,
                                dashStyle: tipoAlimentacionAnt !== true ? 'longdash' : "solid",
                            });
                        } else if (tipoAlimentacionAnt === null)
                            tipoAlimentacionAnt = medicion.alimentacionExterna;
                        else if (i === data.length)
                            zonas.push({
                                value: x,
                                dashStyle: tipoAlimentacionAnt == true ? 'longdash' : "solid",
                            });
                    }
                    //Asignacion de color
                    let colorAsignado;
                    if (this.asignacionColor.get(sensor._id) == undefined) {
                        if (this.ultimoColor == this.colors.length)
                            this.ultimoColor = 0;
                        colorAsignado = this.colors[this.ultimoColor];
                        this.asignacionColor.set(sensor._id, colorAsignado);
                        this.ultimoColor++;
                    } else {
                        colorAsignado = this.asignacionColor.get(sensor._id);
                    }

                    //Alarmas
                    let alarmas = [];
                    if (chart.series.length === 2 || this.checkAlarmasDiferentes() === false) {
                        console.log('plot')
                        alarmas = this.getPlotLinesBySensor(sensor);
                    }
                    //Evaluo si el eje esta agregado
                    if (chart.get(sensor.tipo_id._id + "-ejeY") == null) {
                        //Agrego eje y
                        chart.addAxis({
                            id: sensor.tipo_id._id + "-ejeY",
                            labels: {
                                format: '{value}' + sensor.tipo_id.tipo,
                                style: {
                                    color: "black"
                                }
                            },
                            title: {
                                text: sensor.tipo_id.descripcion,
                                style: {
                                    color: "black"
                                }
                            },
                            opposite: false,
                            //xAxis:1,
                            lineWidth: 1,
                            minorGridLineWidth: 0,
                            lineColor: "black",
                            plotLines: alarmas
                        });
                    }

                    //Agrego serie
                    chart.addSeries({
                        id: sensor._id + "-serie",
                        name: sensor.etiqueta,
                        type: 'line',
                        lineWidth: 2,
                        color: colorAsignado,
                        yAxis: sensor.tipo_id._id + "-ejeY",
                        data: valores,
                        zones: zonas,
                        zoneAxis: "x",
                        tooltip: {
                            valueSuffix: ' ' + sensor.tipo_id.tipo
                        },
                        dataGrouping: {
                            enabled: (valores.length > 30000),
                            approximation: "high"
                        },
                        showInNavigator: true
                    });

                    //Obtengo alarmas
                    if (data.length > 0) {
                        //Alarmas Por Sensor
                        this.regAlarmaService.getRegAlarmasBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone)
                            .subscribe((regAlarmas) => {
                                this.regAlarma.push.apply(this.regAlarma, regAlarmas);
                            });

                        //Alarmas Por nodo
                        let buscarAlarmasPorNodo = true;
                        for (let i = 0; i < this.regAlarmaNodos.length; i++) {
                            let alarma = this.regAlarmaNodos[i];
                            if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
                                buscarAlarmasPorNodo = false;
                                break;
                            }
                        }
                        if (buscarAlarmasPorNodo)
                            this.regAlarmaService.getRegAlarmasByNodoYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone)
                                .subscribe((regAlarmas) => {
                                    this.regAlarmaNodos.push.apply(this.regAlarmaNodos, regAlarmas);
                                })
                    }

                    //Habilitar
                    // for (let ubicacion of this.ubicaciones) {
                    //     for (let sensor of ubicacion.sensores) {
                    //         $("#" + sensor._id).attr('disabled', false);
                    //     }
                    // }
                    this.noData = false;
                }
            );

            //Obtengo promedio
            if (sensor.tipo_id && sensor.tipo_id.descripcion.toLowerCase().includes("temperatura")) {
                this.medicionService.getPromedioMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(
                    (promedio) => {
                        if (promedio.length > 0)
                            this.promedios.set(promedio[0]._id, {
                                valor: this.roundNumber(promedio[0].markAvg, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
                                etiqueta: sensor.etiqueta
                            });
                    })
                this.medicionService.getMKTMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(
                    (promedio) => {
                        if (promedio.mkt)
                            this.promediosMKT.set(promedio._id, {
                                valor: this.roundNumber(promedio.mkt, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
                                etiqueta: sensor.etiqueta
                            });
                    })
                //Obtengo minimo y maximo
                this.medicionService.getMinMaxMedicionesBySensorYFecha(sensor._id, this.fechaDesde, this.fechaHasta, this.offsetTimeZone).subscribe(
                    (data) => {
                        if (data && data.minima && data.maxima) {
                            this.minMaxValues.set(data._id, {
                                minima: this.roundNumber(data.minima.valor, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
                                maxima: this.roundNumber(data.maxima.valor, 2) + (sensor.tipo_id ? (" " + sensor.tipo_id.tipo) : ""),
                                etiqueta: sensor.etiqueta
                            });
                        }
                    })
            }
        } else {

            //Borrar eje y
            if (chart.get(sensor.tipo_id._id + "-ejeY").series.length == 1) {
                chart.get(sensor.tipo_id._id + "-ejeY").remove();
                //Para arreglar error de que se repiten ejes por mas que el eje no se vea en el gráfico
                chart.userOptions.yAxis.some((eje, i) => {
                    if (eje.id == sensor.tipo_id._id + "-ejeY") {
                        chart.userOptions.yAxis.splice(i, 1);
                        return true;
                    }
                });

            } else
                chart.get(sensor._id + "-serie").remove();

            //Borrar Alarmas por sensor
            for (let i = 0; i < this.regAlarma.length; i++) {
                let alarma = this.regAlarma[i];
                if (alarma.sensor_id != null && alarma.sensor_id._id == sensor._id) {
                    var index = this.regAlarma.indexOf(alarma);
                    this.regAlarma.splice(index, 1);
                    i--;
                }
            }

            //Borrar promedio por sensor
            this.promedios.delete(sensor._id);
            this.promediosMKT.delete(sensor._id);
            this.minMaxValues.delete(sensor._id);

            //Borrar Alarmas por nodo
            let borrarNodo = true;
            let cantSensoresSeleccionados = 0;
            let ultimoSensorSeleccionado = null;
            for (let ubicacion of this.ubicaciones) {
                for (let s of ubicacion.sensores) {
                    if ((<HTMLInputElement>document.getElementById(s._id)).checked) {
                        if (s.nodo_id == sensor.nodo_id) {
                            borrarNodo = false;
                        }
                        cantSensoresSeleccionados++;
                        ultimoSensorSeleccionado = s;
                    }
                }
            }
            if (borrarNodo) {
                for (let i = 0; i < this.regAlarmaNodos.length; i++) {
                    let alarma = this.regAlarmaNodos[i];
                    if (alarma.nodo_id != null && alarma.nodo_id._id == sensor.nodo_id) {
                        var index = this.regAlarmaNodos.indexOf(alarma);
                        this.regAlarmaNodos.splice(index, 1);
                        i--;
                    }
                }
            }

            //Muestro cartel de sin datos
            if (chart.series.length == 0)
                this.noData = true;
            setTimeout(function () {
                ChartGlobal.reflow();
            }, 100);

            //Muestro rango de alarmas en caso de que quede un solo sensor seleccionado
            if (cantSensoresSeleccionados === 1 || this.checkAlarmasDiferentes() === false) {
                let ejeY = chart.get(ultimoSensorSeleccionado.tipo_id._id + "-ejeY");
                let alarmas = this.getPlotLinesBySensor(ultimoSensorSeleccionado);
                alarmas.forEach((alarma) => {
                    ejeY.addPlotLine(alarma);
                })
            }
        }
    }

    private getPlotLinesBySensor(sensor) {
        let alarmas = [];
        sensor.alarmas.forEach((alarma) => {
            if (alarma.estado === true) {
                if (alarma && alarma.valorMinimo)
                    alarmas.push({
                        value: alarma.valorMinimo,
                        color: '#D8534E',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: `Min (${alarma.valorMinimo}${sensor.tipo_id.tipo})`
                        }
                    });
                if (alarma && alarma.valorMaximo)
                    alarmas.push({
                        value: alarma.valorMaximo,
                        color: '#D8534E',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: `Max (${alarma.valorMaximo}${sensor.tipo_id.tipo})`
                        }
                    });
                if (alarma && alarma.valorMinimoAmarillo)
                    alarmas.push({
                        value: alarma.valorMinimoAmarillo,
                        color: '#F0AE4E',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: `Min (${alarma.valorMinimoAmarillo}${sensor.tipo_id.tipo})`
                        }
                    });
                if (alarma && alarma.valorMaximoAmarillo)
                    alarmas.push({
                        value: alarma.valorMaximoAmarillo,
                        color: '#F0AE4E',
                        dashStyle: 'shortdash',
                        width: 2,
                        label: {
                            text: `Max (${alarma.valorMaximoAmarillo}${sensor.tipo_id.tipo})`
                        }
                    });
            }
        })
        return alarmas;
    }

    private checkAlarmasDiferentes() {
        let alarmas = null;
        let areDifferent = false;
        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    sensor.alarmas.forEach((alarma, i) => {
                        if (alarma.estado === true) {
                            if (!alarmas)
                                alarmas = {
                                    valorMaximo: alarma.valorMaximo,
                                    valorMinimo: alarma.valorMinimo,
                                    valorMaximoAmarillo: alarma.valorMaximoAmarillo,
                                    valorMinimoAmarillo: alarma.valorMinimoAmarillo,
                                }
                            if (alarma && alarmas && alarma.valorMinimo && alarmas.valorMinimo && alarma.valorMinimo !== alarmas.valorMinimo)
                                areDifferent = true;
                            if (alarma && alarmas && alarma.valorMaximo && alarmas.valorMaximo && alarma.valorMaximo !== alarmas.valorMaximo)
                                areDifferent = true;
                            if (alarma && alarmas && alarma.valorMinimoAmarillo && alarmas.valorMinimoAmarillo && alarma.valorMinimoAmarillo !== alarmas.valorMinimoAmarillo)
                                areDifferent = true;
                            if (alarma && alarmas && alarma.valorMaximoAmarillo && alarmas.valorMaximoAmarillo && alarma.valorMaximoAmarillo !== alarmas.valorMaximoAmarillo)
                                areDifferent = true;
                        }
                    })
                }
            }
        }
        return areDifferent;
    }

    changeColor(e, sensor) {
        var chart = ChartGlobal;
        chart.get(sensor._id + "-serie").update({
            color: e.target.value
        })
        this.asignacionColor.set(sensor._id, e.target.value);
    }

    isChecked(s) {
        if (document.getElementById(s._id))
            return (<HTMLInputElement>document.getElementById(s._id)).checked
        else return false
    }

    modificarBarra() {
        setTimeout(function () {
            ChartGlobal.reflow();
        }, 200);
    }

    ocultarEje() {
        var chart = ChartGlobal;
        this.ejeY = !this.ejeY;
        for (let eje of chart.yAxis) {
            eje.update({
                visible: this.ejeY
            });
        }
    }

    export(tipo) {
        var chart = ChartGlobal;
        var d = new Date();
        var datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
            d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        chart.options.exporting.url = myGlobals.default.BASE_URL + '/informe/grafico';
        chart.options.exporting.chartOptions.title.text = this.empresaSeleccionada.descripcion + " - " + this.sucursalSeleccionada.descripcion;
        chart.options.exporting.chartOptions.subtitle.text = datestring + " - " + this.usuarioConectado.nombre + " " + this.usuarioConectado.apellido;
        chart.options.exporting.chartOptions.subtitle.verticalAlign = 'bottom';
        chart.options.exporting.chartOptions.subtitle.align = 'left';
        chart.options.exporting.chartOptions.chart = {spacing: [20, 20, 60, 20]};
        chart.options.exporting.chartOptions.legend.y = 30;
        chart.options.exporting.chartOptions.legend.maxHeight = 200;
        chart.options.exporting.chartOptions.legend.navigation = {enabled: false};
        let ajuste = this.promedios.size * 30; // Increased space for additional min/max values
        chart.options.exporting.chartOptions.chart.marginTop = 180 + ajuste;
        var fechaDesde = this.fechaDesde.split("-").reverse().join("-");
        var fechaHasta = this.fechaHasta.split("-").reverse().join("-");
        let legenda = "";
        this.promedios.forEach((value, key) => {
            let minMax = this.minMaxValues.get(key);
            let mkt = this.promediosMKT.get(key);
            legenda += "<br/><b>" + value.etiqueta + "</b><br/> Media: " + value.valor + ". MKT: " + (mkt ? mkt.valor : "N/A") + ".";
            if (minMax) {
                legenda += " Min: " + minMax.minima + ". Max: " + minMax.maxima + ".";
            }
        });
        if (tipo == 'application/pdf') {
            if (this.promedios.size > 0)
                chart.options.exporting.chartOptions.chart.events = {
                    load: function () {
                        var renderer = this.renderer;

                        renderer.label(
                            'Valores calculados para el período<br/> <b>Desde: </b>' + fechaDesde + " <b>Hasta: </b>" + fechaHasta + ".  " + legenda,
                            550,
                            chart.plotTop - 120
                        ).attr({
                            zIndex: 5,
                            fill: '#FFFFEF',
                            stroke: 'gray',
                            'stroke-width': 1,
                        }).css({
                            width: '250px',
                            padding: "5px",
                        })
                            .add();
                    }
                };
            chart.options.exporting.chartOptions.legend.itemStyle = {fontSize: '10px'};
            chart.options.exporting.sourceWidth = 842;
            chart.options.exporting.sourceHeight = 595;
            chart.options.exporting.scale = 0.2;
            // chart.options.exporting.sourceWidth = 3508 / 12;
            // chart.options.exporting.sourceHeight = 2480 / 12;
            // chart.options.exporting.scale = 3;
        } else {
            if (this.promedios.size > 0)
                chart.options.exporting.chartOptions.chart.events = {
                    load: function () {
                        var renderer = this.renderer;

                        renderer.label(
                            'Valores calculados para el período<br/> <b>Desde: </b>' + fechaDesde + " <b>Hasta: </b>" + fechaHasta + ".  " + legenda,
                            900,
                            chart.plotTop - 110
                        ).attr({
                            zIndex: 5,
                            fill: '#FFFFEF',
                            stroke: 'gray',
                            'stroke-width': 1,
                        }).css({
                            width: '250px',
                            padding: "5px",
                        })
                            .add();
                    }
                };
            chart.options.exporting.chartOptions.legend.itemStyle = {fontSize: '12px'};
            chart.options.exporting.sourceWidth = 3508 / 3;
            chart.options.exporting.sourceHeight = 2480 / 3;
            chart.options.exporting.scale = 3;
        }

        chart.options.exporting.filename = this.empresaSeleccionada.descripcion + "-" + this.sucursalSeleccionada.descripcion + "-" + datestring;

        chart.exportChart({
            type: tipo
        });
    }

    exportCSV() {
        var chart = ChartGlobal;
        const linkSource = `data:text/csv;charset=utf-8,${escape(chart.getCSV())}`;
        const downloadLink = document.createElement("a");
        const fileName = "datosSensoresHistorico" + ".csv";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    exportInformeResumen() {
        let reporte = <any>{};
        reporte.fechaDesde = this.fechaDesde;
        reporte.fechaHasta = this.fechaHasta;
        reporte.nodos = [];
        reporte.sensores = [];
        var chart = ChartGlobal;
        reporte.svg = chart.getSVG({
            title: {text: this.empresaSeleccionada.descripcion + " - " + this.sucursalSeleccionada.descripcion},
            exporting: {sourceWidth: 3508 / 3, sourceHeight: 2480 / 3}
        });
        var doc = new DOMParser().parseFromString(reporte.svg, "text/xml");
        reporte.svg = window.btoa(unescape(encodeURIComponent(new XMLSerializer().serializeToString(doc))));
        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                if ((<HTMLInputElement>document.getElementById(sensor._id)).checked == true) {
                    const nodoId = typeof sensor.nodo_id === 'string' ? sensor.nodo_id : sensor.nodo_id._id;
                    if (reporte.nodos.indexOf(nodoId) == -1)
                        reporte.nodos.push(nodoId);
                    if (reporte.sensores.indexOf(sensor._id) == -1)
                        reporte.sensores.push(sensor._id)
                }
            }
        }
        this.loading = true;
        this.informeService.getInformeResumen(this.sucursalSeleccionada._id, reporte)
            .subscribe((res) => {
                this.loading = false;
            })
    }

    ocultarBarraSelectora() {
        if ($('#barraSelectora').css("display") == "block")
            $('#barraSelectora').css("display", "none");
        else
            $('#barraSelectora').css("display", "block");
    }

    private uncheckAllSensors() {
        for (let ubicacion of this.ubicaciones) {
            for (let sensor of ubicacion.sensores) {
                const checkbox = <HTMLInputElement>document.getElementById(sensor._id);
                if (checkbox && checkbox.checked) {
                    checkbox.checked = false;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/historico/historico.component.ts